import { render, staticRenderFns } from "./AccessPolicy.vue?vue&type=template&id=045a4354&"
import script from "./AccessPolicy.vue?vue&type=script&lang=ts&"
export * from "./AccessPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports